import React from 'react'
import PropTypes from 'prop-types'
import { shuffle } from 'lodash'
import PageTitle from '../features/ui/util/page_title'
import DefaultLayout from '../layouts/default_layout'
import { LinkFooter } from '../features/ui/util/async_components'
import RandomSidebarPanels from '../components/sidebar/random_sidebar_panels'

class LinkPage extends React.PureComponent {

  render() {
    const {
      children,
      page,
      title,
    } = this.props

    const items = RandomSidebarPanels()
    const sidebarLayout = [
      ...shuffle(items),
      LinkFooter,
    ]

    return (
      <DefaultLayout
        showBackBtn
        title={title}
        page={page}
        layout={sidebarLayout}
      >
        <PageTitle path={title} />
        {children}
      </DefaultLayout>
    )
  }

}

LinkPage.propTypes = {
  children: PropTypes.node.isRequired,
  page: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
}

export default LinkPage